import { apiPCSEnabled, apiGetPCSI18nJSON, apiGetResponseServerData } from '@/resource/pcs'
import { I18N_PAYMENT_CENTER_MAP } from '@/constants/language'

export default {
  async actionSetAvailableWithdrawTypes({ commit, state }, types) {
    commit('setAvailableWithdrawTypes', types)
  },
  actionSetWithdrawSortInfo({ commit }, data) {
    commit('setWithdrawSortInfo', data)
  },
  actionSetIsUsePcs({ commit }, data) {
    return new Promise((resolve, reject) => {
      apiPCSEnabled().then(result => {
        let data = result.data
        commit('setIsUsePcs', data.data)
        resolve(data)
      })
    })
  },
  actionSetWithdrawName({ commit }, data) {
    commit('setWithdrawName', data)
  },
  async actionSetPCSI18n({ commit, rootState }, data) {
    try {
      const lang = I18N_PAYMENT_CENTER_MAP[rootState.common.lang] || 'en_US'
      const resUrl = await apiGetPCSI18nJSON(lang)

      if (resUrl.data.code === 0 && resUrl.data.data) {
        const res = await apiGetResponseServerData(resUrl.data.data)
        commit('setPCSI18n', res.data)
      } else {
        console.log('Invalid response from apiGetPCSI18nJSON')
      }
    } catch (error) {
      console.error('Error in actionSetPCSI18n:', error)
    }
  },
  actionSetPercentageFee({ commit }, data) {
    commit('setPercentageFee', data)
  },
  actionSetCalculatedAmount({ commit }, data) {
    commit('setCalculatedAmount', data)
  },
  actionSetShowFee({ commit }, data) {
    commit('setShowFee', data)
  },
}
